// App-wide constants. Single source of truth for limits, timings, and
// other "magic numbers" previously sprinkled across components.

/** Minimum number of valid guest codes required to confirm a table. */
export const MIN_GUESTS = 5;

/** Maximum number of guests allowed per reservation in the initial flow. */
export const MAX_GUESTS = 10;

/** Default cap on additional guests added during the extension flow. */
export const DEFAULT_MAX_ADDITIONAL_GUESTS = 5;

/** Booking-code formatting rules. */
export const BOOKING_CODE_MAX_LENGTH = 10;
export const BOOKING_CODE_PATTERN = /[^A-Z0-9]/g;

/** Zoom-to-table animation duration (ms). */
export const ZOOM_ANIMATION_MS = 500;
/** Zoom-out animation duration (ms). */
export const ZOOM_OUT_ANIMATION_MS = 300;

/** STOMP/WebSocket reconnect attempts before giving up. */
export const WS_MAX_RETRIES = 5;
/** Base delay (ms) between WS reconnect attempts (exponential backoff). */
export const WS_BASE_RETRY_DELAY_MS = 1000;

/** Fallback SVG viewBox when the room bounding box can't be computed. */
export const DEFAULT_VIEWBOX = '0 0 1000 1000';

/** API base path (relative to current host). */
export const API_BASE_PATH = '/seatmap_api/';
